import React from "react";
import { ChildIssueListContext } from "./CmtListTable";
import CmtChildIssueList from "./CmtChildIssueList";
import { useSelector } from "react-redux";

export default function CmtIssueChildren(props) {
  const { issue, tabId, detailViewIsAuthorized } = props;

  const fetching = useSelector((state) => state.qms.fetching);

  return (
    <>
      {issue && issue.childIssues ? (
        <ChildIssueListContext.Provider
          value={{ data: { issueId: issue.issueId, fetchListOnly: false, tabId } }}
        >
          <CmtChildIssueList
            tabId={tabId}
            divisionId={issue ? issue.divisionId : null}
            showAddButton={detailViewIsAuthorized}
          />
        </ChildIssueListContext.Provider>
      ) : (
        fetching && "Loading..."
      )}
    </>
  );
}
